/* Copyright(c) 2018, iovation, inc. All rights reserved. */
const isLocal =
  window.location.hostname === 'localhost' ||
  process.env.PHOENIX_ENVIRONMENT === 'local';

window.IGLOO = window.IGLOO || {
  loader: {
    version: 'general5',
    fp_static: !isLocal,
    fp_dyn: !isLocal,
  },
};
